import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { generateClient } from 'aws-amplify/api';
import { createConnectionConfigTable, updateConnectionConfigTable, deleteConnectionConfigTable } from '../graphql/mutations';
import { getConnectionConfigTable } from '../graphql/queries';

const client = generateClient();

const Connection = () => {
  const navigate = useNavigate();
  let id = useParams()?.id;
  const [status, setStatus] = useState({ message: "" });
  const [connectionInfo, setConnectionInfo] = useState({
    originalName: "",
    name: "",
    accountId: "",
    token: "",
    tokenSecret: "",
    externalUser: "automation@rfsmart.com",
    rfsmartRestlet: "/app/site/hosting/restlet.nl?script=customscript_rfs_ss_api&deploy=customdeploy_rfs_ss_api",
    automationRestlet: "/app/site/hosting/restlet.nl?script=customscript_rfs_atmn_api&deploy=customdeploy_rfs_atmn_api",
    expirationDate: "",
    customerName: "",
    emailAddress: "",
    version: 0
  })

  useEffect(() => {
    async function fetchData() {
      if (id && id.length > 0) {
        const connectionDetails = {
          id: id,
        };
        const result = await client.graphql({
          query: getConnectionConfigTable,
          variables: connectionDetails
        });
        if (result) {
          const dbData = {
            originalName: result.data.getConnectionConfigTable.Name,
            name: result.data.getConnectionConfigTable.Name,
            accountId: result.data.getConnectionConfigTable.AccountId,
            token: result.data.getConnectionConfigTable.Token,
            tokenSecret: result.data.getConnectionConfigTable.TokenSecret,
            externalUser: result.data.getConnectionConfigTable.ExternalUser,
            rfsmartRestlet: result.data.getConnectionConfigTable.RfsmartRestlet,
            automationRestlet: result.data.getConnectionConfigTable.AutomationRestlet,
            expirationDate: result.data.getConnectionConfigTable.ExpirationDate,
            customerName: result.data.getConnectionConfigTable.CustomerName,
            emailAddress: result.data.getConnectionConfigTable.EmailAddress
          };
          setConnectionInfo(dbData);
        }
      }
    }
    fetchData();
  }, [id]);

  const onChange = (e) => {
    setConnectionInfo({ ...connectionInfo, [e.target.id]: e.target.value });
  };

  const onBlur = (e) => {
    setConnectionInfo({ ...connectionInfo, [e.target.id]: e.target.value.trim() });
  };

  const onDateChange = (e) => {
    if (isValidDate(e.target.value)) {
      setConnectionInfo({ ...connectionInfo, [e.target.id]: e.target.value.trim() });
      setStatus({ message: '' });
    } else {
      setStatus({ message: 'Expriation Date is invalid' });
    }
  };
  // Validates that the input string is a valid date formatted as "mm/dd/yyyy"
  function isValidDate(dateString) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
      return false;

    // Parse the date parts to integers
    var parts = dateString.split("/");
    var day = parseInt(parts[1], 10);
    var month = parseInt(parts[0], 10);
    var year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month == 0 || month > 12)
      return false;

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
      monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  };

  const onCheckedChange = (e) => {
    setConnectionInfo({ ...connectionInfo, [e.target.id]: e.target.checked });
  };

  async function updateConnection() {
    if (new Date(connectionInfo.expirationDate) < Date.now()) {
      setStatus({ message: 'Invalid Expiration Date. Date is before today.' });
      return;
    }

    if (connectionInfo.originalName === connectionInfo.name && id && id.length > 0) {
      //update
      var connectionData = {
        id: id,
        Name: connectionInfo.name,
        AccountId: connectionInfo.accountId,
        Token: connectionInfo.token,
        TokenSecret: connectionInfo.tokenSecret,
        ExternalUser: connectionInfo.externalUser,
        RfsmartRestlet: connectionInfo.rfsmartRestlet,
        AutomationRestlet: connectionInfo.automationRestlet,
        ExpirationDate: connectionInfo.expirationDate,
        CustomerName: connectionInfo.customerName,
        EmailAddress: connectionInfo.emailAddress
      };
      const connectionDetails = {
        Name: { eq: connectionInfo.name }
      };
      var test = await client.graphql({ query: updateConnectionConfigTable, variables: { input: connectionData, condition: connectionDetails } });

      setStatus({ message: 'Update Successful' });
    }
    else {
      var connectionData = {
        Name: connectionInfo.name,
        AccountId: connectionInfo.accountId,
        Token: connectionInfo.token,
        TokenSecret: connectionInfo.tokenSecret,
        ExternalUser: connectionInfo.externalUser,
        RfsmartRestlet: connectionInfo.rfsmartRestlet,
        AutomationRestlet: connectionInfo.automationRestlet,
        ExpirationDate: connectionInfo.expirationDate,
        CustomerName: connectionInfo.customerName,
        EmailAddress: connectionInfo.emailAddress
      };
      await client.graphql({ query: createConnectionConfigTable, variables: { input: connectionData } });
      setStatus({ message: 'Insert Successful' });
      navigate("/connections/")
    }
    console.log("Connection saved");
  }

  async function deleteConnection() {
    if (id && id.length > 0) {
      const connectionDetails = {
        id: id,
      };
      const deletedSetup = await client.graphql({ query: deleteConnectionConfigTable, variables: { input: connectionDetails } });
    }
  }

  const onDelete = (e) => {
    e.preventDefault();
    deleteConnection();
    setStatus({ message: 'Delete Successful' });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    updateConnection();
    console.log(connectionInfo);
  };

  return (
    <form className="ui form" onSubmit={onSubmit}>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="name">Connection Name</label>
          <input type="text" className="ui fluid input" placeholder="Connection Name" id="name" value={connectionInfo.name} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="accountId">Account Id</label>
          <input type="text" className="ui fluid input" placeholder="Account Id" id="accountId" value={connectionInfo.accountId} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="externalUser">External User</label>
          <input type="text" className="ui fluid input" placeholder="External User" id="externalUser" value={connectionInfo.externalUser} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="customerName">Customer Name</label>
          <input type="text" className="ui fluid input" placeholder="Customer Name" id="customerName" value={connectionInfo.customerName} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="expirationDate">Expiration Date MM/dd/yyyy</label>
          <input type="text" className="ui fluid input" placeholder="Expiration Date" id="expirationDate" value={connectionInfo.expirationDate} onChange={onChange} onBlur={onDateChange} required={true} />
        </div>
        <div className="field">
          <label htmlFor="emailAddress">Notification Email Address</label>
          <input type="text" className="ui fluid input" placeholder="Notification Email Address" id="emailAddress" value={connectionInfo.emailAddress} onChange={onChange} onBlur={onBlur} />
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="token">Token</label>
          <input type="text" className="ui fluid input" placeholder="Token" id="token" value={connectionInfo.token} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="tokenSecret">Token Secret</label>
          <input type="text" className="ui fluid input" placeholder="Token Secret" id="tokenSecret" value={connectionInfo.tokenSecret} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="rfsmartRestlet">RF-SMART Restlet</label>
          <input type="text" className="ui fluid input" placeholder="RF-SMART Restlet" id="rfsmartRestlet" value={connectionInfo.rfsmartRestlet} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="automationRestlet">Automation Restlet</label>
          <input type="text" className="ui fluid input" placeholder="Automation Restlet" id="automationRestlet" value={connectionInfo.automationRestlet} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <button className="ui button" type="submit" >Submit</button>
        </div>
      </div>
      <div>{status.message}</div>
    </form>
  )
}

export default Connection;